import { Text } from "./text";

class Textarea extends Text {
  constructor(field) {
    super(field);
    this.displaySelectType = "TEXTAREA";
  }
}

export { Textarea };
